module.exports = __webpack_public_path__ + "img/07_shimizu_13.5ec0a9ae.jpg";